import React from "react";
import '../css/homepage_org.css';

function Footer() {
  return (
    <footer>
      <p>© 2026 Buydeal.eu B.V. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
